<template>
    <div>
        <div v-if="this.endChurchPinTour" class="text-center">
            <v-btn
                fixed
                size="x-large"
                icon
                location="bottom right"
                
                color="#a5d867"
                @click="startTour"
            ><v-icon @click="startTour">$guide</v-icon></v-btn>
        </div>
        <v-tour name="myChurchPinTour" class="app-church-pin-tour" :steps="churchPinSteps" :callbacks="myCallbacks" :options="tourOptions"></v-tour>
    </div>
</template>

<script>
  export default {
    name: 'my-church-pin-tour',
    data () {
        return {
            endChurchPinTour: null,
            myCallbacks: {
                onSkip: this.customSkipCallback,
                onFinish: this.customFinishCallback
            },
        }
    },
    computed: {
        tourOptions () {
            return {
                labels: {
                    buttonSkip: this.$t('common.tourSkip'),
                    buttonPrevious: this.$t('common.tourPrevious'),
                    buttonNext: this.$t('common.tourNext'),
                    buttonStop: this.$t('common.tourFinish'),
                },
            }
        },
        churchPinSteps () {
            return [
                {
                    target: '.church-pin-componant',
                    header: {
                        title: this.$t('welcome.churchPinTour.pinTitle'),
                    },
                    content: this.$t('welcome.churchPinTour.pinContent'),
                    params: {
                        placement: 'bottom', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                        enableScrolling: false,
                    }
                },
                {
                    target: '.menu-items-container',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('welcome.churchPinTour.menuTitle'),
                    },
                    content: this.$t('welcome.churchPinTour.menuContent'),
                    params: {
                        placement: 'left',
                        enableScrolling: false,
                        highlight: true,
                    },
                },
            ]
        },
    },
    methods: {
        customSkipCallback () {
            this.endChurchPinTour = true
            localStorage.endChurchPinTour = true
        },
        customFinishCallback () {
            this.endChurchPinTour = true
            localStorage.endChurchPinTour = true
        },
        startTour () {
            localStorage.removeItem('endChurchPinTour')
            this.endChurchPinTour = null
            this.$tours['myChurchPinTour'].start()
        }
    },
    mounted: function () {
        this.endChurchPinTour = localStorage.endChurchPinTour
        if(!localStorage.endChurchPinTour) {
            setTimeout(() => {
                this.$tours['myChurchPinTour'].start()
            }, 500);
        }
    }
  }
</script>
<style>

</style>